import React from 'react';

import { Link } from 'react-router';
import Logo from '../../images/logo.png';

export default class StaticHeader extends React.Component {
  render() {
    return (
      <div className="header-wrapper">
        <div className="content">
          <div className="logo-wrapper">
            <Link to="/">
              <img src={Logo} role="presentation" />
            </Link>
          </div>
        </div>
      </div>
    )
  }
}


/** WEBPACK FOOTER **
 ** ./src/views/Home/StaticHeader.js
 **/